import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { ChevronDownIconComponent } from '@kuiper/icons';
import {
  DepartmentTreeItem,
  DepartmentTreeNode,
  OrgChartPositionNode,
} from '../../department-model';
import { AvatarPipe } from '../../../../../../../ui-components/pipes/avatar/avatar.pipe';
import { TooltipDirective } from '../../../../../../../ui-components/lib/tooltip/tooltip.directive';
import { centeredScrollOffset } from './department-org-chart-scroll';

@Component({
  selector: 'lib-department-org-chart',
  imports: [
    NgTemplateOutlet,
    TranslocoPipe,
    ChevronDownIconComponent,
    AvatarPipe,
    TooltipDirective,
  ],
  templateUrl: './department-org-chart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentOrgChartComponent {
  readonly roots = input.required<DepartmentTreeNode[]>();
  readonly expandedIds = input.required<ReadonlySet<number>>();
  readonly expandAll = input(false);
  readonly positionForests =
    input.required<ReadonlyMap<number, OrgChartPositionNode[]>>();

  readonly toggleExpanded = output<number>();
  readonly selectDepartment = output<DepartmentTreeItem>();

  private readonly chartScroll =
    viewChild<ElementRef<HTMLElement>>('chartScroll');

  protected readonly noPositions: OrgChartPositionNode[] = [];
  protected readonly nameTooltipClass =
    'bg-white p-md rounded-lg shadow-lg !w-auto tooltip-arrow tooltip-arrow-top';

  constructor() {
    afterRenderEffect({
      write: () => {
        this.roots();
        this.expandedIds();
        this.expandAll();
        this.positionForests();
        this.centerHorizontalScroll();
      },
    });
  }

  centerHorizontalScroll(): void {
    const chart = this.chartScroll()?.nativeElement;
    if (!chart) {
      return;
    }
    chart.scrollLeft = centeredScrollOffset(chart.scrollWidth, chart.clientWidth);
  }
}
